import PageProps from '@leuven2030/food/Page/PageProps';
import React, { useContext } from 'react';
import Head from 'next/head';
import 'twin.macro';
import Page, { PageContext } from '@leuven2030/framework/Page/Page';
import { AllPartnersQuery } from '@leuven2030/framework/Partner/PartnersQuery';
import PartnerItem from '@leuven2030/food/Partner/PartnerItem';
import ContentCover from '@leuven2030/framework/Content/ContentCover';
import PageLayoutDefault from '@leuven2030/food/Page/PageLayoutDefault';
import { StyleContent } from '@leuven2030/food/styles/general';

import { gql } from '@apollo/client';
const PartnersPage = () => {
  const {
    prismic: {
      partners_page: { title, cover, description },
      allPartners: { edges }
    }
  } = useContext(PageContext);
  return (
    <PageLayoutDefault>
      {/* <ContentCover image={cover} title={title} /> */}
      <div tw="bg-primary-400 py-12">
        <div css={StyleContent}>
          <div tw="flex flex-col space-y-6 sm:(flex-row items-start justify-between space-x-3 space-y-0) w-full">
            <div tw="space-y-4">
              <h1 tw="text-white font-black text-3xl sm:text-4xl">{title}</h1>
              <p tw="text-white text-lg lowercase">{description}</p>
            </div>
          </div>
        </div>
      </div>
      <div tw="my-10" css={StyleContent}>
        <div tw="grid grid-cols-1 md:grid-cols-3 lg:mt-8 gap-6 ">
          {edges.map(({ node }, index) => {
            return <PartnerItem {...node} key={index} />;
          })}
        </div>
      </div>
    </PageLayoutDefault>
  );
};

export const getStaticProps = PageProps({
  prismic: {
    query: gql`
        query {
            ${AllPartnersQuery}
            partners_page(uid:"partners",lang:"nl-be"){
                title
                description
                cover{
                    ... on _ImageLink{
                        url
                    }
                }
            }
           
        }
    `
  }
});
export default Page(PartnersPage);
